import { render, staticRenderFns } from "./UserEditForm.vue?vue&type=template&id=7e54a870&scoped=true&"
import script from "./UserEditForm.vue?vue&type=script&lang=ts&"
export * from "./UserEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54a870",
  null
  
)

export default component.exports